import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import {
  Menu,
  MenuListItem,
  Input,
  IconArrowDropUp,
  IconArrowDropDown,
  BaseInputField,
  SearchInput,
  INPUT_SIZES
} from 'cdk-radial';

const TRUNCATION_CHAR_CUTOFF = 60;

const StyledInput = styled(Input)`
  ${BaseInputField} {
    cursor: pointer;
  }

  svg {
    cursor: pointer;
  }
`;

// TODO revive search features once radial team answers us

export default function LocationsDropdownMenu({ options, onChange = () => {} }) {
  const targetRef = useRef();
  const dimensionRef = useRef();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [searchInput, setSearchInput] = useState('');
  const [searchResults, setSearchResults] = useState([]);

  const isAllSelected = selectedOptions.length === options.length;
  const isAnySelected = selectedOptions.length > 0;
  const isIndeterminate = !isAllSelected && isAnySelected;

  useEffect(() => {
    setSearchResults(options.filter(opt => (
      opt.label?.toLowerCase().includes(searchInput.toLowerCase()))
    ));
  }, [searchInput, options]);

  /*
  const handleSearchChange = value => {
    setSearchInput(value);
  }
   */

  const handleSelect = (option) => {
    const newSelectedOptions = selectedOptions.filter(
      (opt) => opt.value !== option.value
    );
    const isAlreadySelected =
      newSelectedOptions.length !== selectedOptions.length;
    if (isAlreadySelected) {
      setSelectedOptions(newSelectedOptions);
      onChange(newSelectedOptions);
    } else {
      const updatedSelectedOptions = [option, ...selectedOptions];
      setSelectedOptions(updatedSelectedOptions);
      onChange(updatedSelectedOptions);
    }
  };

  const handleAllSelect = () => {
    if (!isAnySelected) {
      const optionsExcludingDisabled = options.filter(
        (option) => !option.isDisabled
      );
      setSelectedOptions(optionsExcludingDisabled);
      onChange(optionsExcludingDisabled);
      return;
    }
    setSelectedOptions([]);
    onChange([]);
  };

  const handleOpen = () => {
    setIsOpen(isOpen => !isOpen);
  };

  const getIsOptionSelected = option => {
    return selectedOptions.some(opt => opt.value === option.value);
  };

  const getValue = () => {
    if (isIndeterminate) {
      let displayString = selectedOptions[0].label;
      for (let i = 1; i < selectedOptions.length; i++) {
        const opt = selectedOptions[i];
        let newDisplayString = `${displayString}, ${opt.label}`;
        if (newDisplayString.length > TRUNCATION_CHAR_CUTOFF) {
          // if there's just one element taking up all the space, cut it down
          // so we can still see the "+ N more"
          if (i === 1 && displayString.length > TRUNCATION_CHAR_CUTOFF) {
            displayString = `${displayString.substring(0, TRUNCATION_CHAR_CUTOFF)}…`;
          }
          displayString = `${displayString} + ${selectedOptions.length - i} more`;
          break;
        } else {
          displayString = newDisplayString;
        }
      }
      return displayString;
    }
    if (isAllSelected) {
      return 'All Locations';
    }
  };

  return (
    <>
      <div style={{ width: '600px' }} data-testid="transaction-report__select-locations">
        <StyledInput
          dataTestId="transaction-report__select-locations-input"
          icon={isOpen ? <IconArrowDropDown /> : <IconArrowDropUp />}
          id="transaction-report__select-locations"
          label="Locations"
          labelRef={dimensionRef}
          name="transaction-report__select-locations"
          onChange={() => {}}
          placeholder="Select..."
          ref={targetRef}
          value={getValue() || ''}
          style={{ caretColor: 'transparent' }}
          autoComplete="off"
        />
      </div>
      <Menu
        dataTestId="transaction-report__select-locations-menu-container"
        dimensionRef={dimensionRef}
        isAuto={false}
        labelRef={targetRef}
        multi
        onClose={handleOpen}
        onOpen={handleOpen}
        style={{
          width: 'auto',
          minWidth: '240px',
          maxWidth: '600px',
          minHeight: '240px',
          maxHeight: '400px'
        }}
      >
        {/*
        <div className="transaction-report__menu-search">
          <SearchInput
            name="transaction-report__select-locations-search"
            id="transaction-report__select-locations-search"
            placeholder="Search"
            size={INPUT_SIZES.SMALL}
            isAlwaysExpanded={true}
            value={searchInput}
            onChange={handleSearchChange}
          />
        </div>
        */}
        <MenuListItem
          onClick={handleAllSelect}
          isSelected={isAllSelected || isIndeterminate}
          indeterminate={isIndeterminate}
          showDivider
          hideSelectedItemCheckmark={false}
        >
          All Locations
        </MenuListItem>
        {(searchInput ? searchResults : options).map(option => {
          return (
            <MenuListItem
              key={option.value}
              isSelected={getIsOptionSelected(option)}
              onClick={() => handleSelect(option)}
              isDisabled={option.disabled}
              showDivider={option.showDivider}
              hideSelectedItemCheckmark={false}
            >
              {option.label}
            </MenuListItem>
          );
        })}
      </Menu>
    </>
  );
};
